module.exports = __webpack_public_path__ + "static/media/ec10.fd49ca89.jpg";